'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nodePolyglot = require('node-polyglot');

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _globalCache = require('global-cache');

var _globalCache2 = _interopRequireDefault(_globalCache);

var _generateKey = require('./generateKey');

var _generateKey2 = _interopRequireDefault(_generateKey);

var _pluralRules = require('./pluralRules');

var _pluralRules2 = _interopRequireDefault(_pluralRules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var singletonKey = 'polyglot singleton';
// better hide the global cache, so it's harder for people to discover that I'm
// a bad engineer and a horrible person

var silenceWarnings = process.env.SILENCE_POLYGLOT_WARNINGS;
var noop = function noop() {};
var warn = function warn(condition, message) {
  if (!silenceWarnings) {
    (0, _warning2['default'])(condition, message);
  }
};

exports['default'] = _globalCache2['default'].setIfMissingThenGet(singletonKey, function () {
  var options = { pluralRules: _pluralRules2['default'] };
  if (silenceWarnings) {
    options.warn = noop;
  }
  var polyglot = new _nodePolyglot2['default'](options);
  var originalT = polyglot.t;

  var wrappedT = function () {
    function wrappedT(key, opts) {
      var newOpts = Object.assign({}, opts);
      if (opts && opts._) {
        throw new TypeError('Expected a default key, found _.');
      }
      if (newOpts['default']) {
        newOpts._ = newOpts['default'];
        delete newOpts['default'];
      }

      return originalT.call(polyglot, key, newOpts);
    }

    return wrappedT;
  }();

  var prefix = '';

  polyglot.setPhrasePrefix = function () {
    function setPrefix(newPrefix) {
      prefix = newPrefix;
    }

    return setPrefix;
  }();

  polyglot.phrase = function () {
    function phrase(defaultPhrase, params) {
      var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      var key = (0, _generateKey2['default'])(prefix, defaultPhrase, context);
      warn(context, '[airbnb-i18n] Missing context for phrase "' + String(defaultPhrase) + '".');
      if (!polyglot.has(key)) {
        var opts = Object.assign({ _: defaultPhrase }, params);
        return originalT.call(polyglot, key, opts);
      }
      return originalT.call(polyglot, key, params);
    }

    return phrase;
  }();

  polyglot.t = wrappedT;

  return polyglot; // I'm sorry!
  // Basically, since different JS bundles each contain a different instance of this module,
  // installing it on the global object is the only temporary workaround that works both
  // in the browser, and in the command line for tests (also in mystique), to get all bundles
  // to share this singleton instance.
  // One day, soon hopefully, we will get factored bundles and remove duplication, at which
  // time, we can remove this hack, and have just a module-level closed-over variable.
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-i18n/index.js
// module id = 160
// module chunks = 168707334958949